module.exports = __webpack_public_path__ + "static/media/f_levels_3-6.46ebad8f.png";